function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 22.539a7.484 7.484 0 01-4.276-1.328l10.487-10.487A7.484 7.484 0 0122.539 15a7.49 7.49 0 01-2.208 5.33A7.49 7.49 0 0115 22.54M9.67 9.669A7.49 7.49 0 0115 7.461c1.55 0 3.028.465 4.276 1.328L8.789 19.276A7.484 7.484 0 017.461 15 7.49 7.49 0 019.67 9.67m12.402-1.741c-3.905-3.905-10.237-3.905-14.142 0-3.905 3.905-3.905 10.237 0 14.142 3.905 3.905 10.237 3.905 14.142 0 3.905-3.905 3.905-10.237 0-14.142",
  fill: "#0592AF"
});

function SvgNoScoreIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _ref);
}

export default SvgNoScoreIcon;